import * as React from "react";

function SvgFirewallConnectDuo({ title, titleId, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path
          fill="#374151"
          d="M13.915 2.579l.263.1 4.864 1.99a2.75 2.75 0 011.702 2.36l.006.185v4.028c0 4.709-3.385 9.094-8.025 10.407-.17.049-.344.08-.52.093l-.233.008a2.684 2.684 0 01-.696-.1c-4.548-1.287-7.89-5.525-8.022-10.126l-.004-.282V7.214c0-1.055.603-2.011 1.54-2.47l.169-.075 4.864-1.99a5.74 5.74 0 014.092-.1zM11.25 3.817c-.219.04-.436.096-.648.17l-.211.08-4.865 1.99a1.25 1.25 0 00-.768 1.02l-.008.137v4.028c0 3.884 2.723 7.554 6.5 8.83V3.817z"
        />
        <path
          fill="#98DB69"
          d="M12.75 3.817l.001 16.254c3.689-1.247 6.372-4.776 6.495-8.558l.004-.271V7.214a1.25 1.25 0 00-.652-1.098l-.124-.059-4.864-1.99a4.245 4.245 0 00-.86-.25z"
        />
      </g>
    </svg>
  );
}

export default SvgFirewallConnectDuo;
